import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;

if (!posthogKey || !posthogHost) {
  console.warn('PostHog environment variables not found. Analytics will be disabled.');
}

const options = {
  api_host: posthogHost || 'https://us.i.posthog.com',
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const AppWithProviders = () => {
  if (!posthogKey) {
    return (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  }

  return (
    <PostHogProvider 
      apiKey={posthogKey}
      options={options}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  );
};

root.render(
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>
); 